module.exports = __webpack_public_path__ + "img/icon_mianxi@2x.ed4d11be.png";